import { ICONS } from '~/constants/icons';
import { getPlotSize } from '@habity/services';
import { DataFieldConfig, forEstateTypes } from './data-builder';
import { NestedHome } from '@habity/types';
import { capitalize } from 'lodash';
import { isFarm } from '@habity/types/vitec/assertions';
import { FarmInfoEstateEconomyBuilding } from '@habity/types/vitec/common/farmInfoEstateEconomyBuilding';

const getBuildingIcon = (heading: string) => {
  return undefined;
};

export const getEconomyBuildingsFromHome = (context: { home: NestedHome }) => {
  const { home } = context;
  const { provider_data, provider_type } = home || {};
  if (!provider_data || !provider_type) return [];

  if (isFarm(provider_data, provider_type)) {
    // @ts-ignore
    const { economyBuildings } = provider_data || {};
    return economyBuildings;
  }

  return [];
};

// Create dynamic fields based on economy buildings data
export const createEconomyBuildingsFields = (context: {
  home: NestedHome;
}): DataFieldConfig[] => {
  const economyBuildings = getEconomyBuildingsFromHome(context);

  if (!economyBuildings || economyBuildings.length === 0) return [];

  // If economyBuildings is an array of building objects with name and description
  if (
    Array.isArray(economyBuildings) &&
    economyBuildings.length > 0 &&
    typeof economyBuildings[0] === 'object' &&
    economyBuildings[0].name
  ) {
    return economyBuildings.map(
      (building: FarmInfoEstateEconomyBuilding, index: number) => ({
        key: `economy_building_${index}`,
        label: capitalize(building.name || `Ekonomibyggnad ${index + 1}`),
        icon: getBuildingIcon(building.name || ''),
        getValue: () => building.description || '',
        condition: () => true, // Always include if building exists
      })
    );
  }

  // If economyBuildings is a simple value (fallback)
  return [
    {
      key: 'economy_buildings_fallback',
      label: 'Ekonomibyggnader',
      icon: getBuildingIcon(''),
      getValue: () => economyBuildings?.toString() || '',
      condition: () => true,
    },
  ];
};

export const economyBuildingsFields: DataFieldConfig[] = [];
